import { GetStaticPropsContext } from 'next';

import { LoggedInHomepage as LoggedInHomepageNoGql } from './pages/HomepageLoggedIn';
import { LoggedOutHomepage as LoggedOutHomepageNoGql } from './pages/HomepageLoggedOut';
import { initializeApollo, graphQLWrapper } from '@zoopla/apollo';
import HOMEPAGE_QUERY from './queries/homepage.query';
import { HomepageQuery } from './queries/homepage.query.generated';
import { pLogger } from '@zoopla/logger';

export const LoggedInHomepage = graphQLWrapper(LoggedInHomepageNoGql);
export const LoggedOutHomepage = graphQLWrapper(LoggedOutHomepageNoGql);

const homepageLogger = pLogger.child({ page: 'homepage', custodian: 'lol' });

export async function getStaticProps({ preview }: GetStaticPropsContext) {
    const apolloClient = initializeApollo(null);

    try {
        const homepage = await apolloClient?.query<HomepageQuery>({
            query: HOMEPAGE_QUERY,
            variables: {
                articleLimit: 12,
                preview
            }
        });
        const homepageData = homepage?.data?.homepage || {};

        return {
            props: {
                ...homepageData
            },
            revalidate: 600 // 10 mins
        };
    } catch (error) {
        homepageLogger.error(error, 'error on the homepage');
        return {
            props: {},
            revalidate: 300
        };
    }
}
